<template>
  <div class="grid__item card-919">
    <div class="card card--primary">
      <div class="card__top">
        <slot name="p-1">
          <div class="badge badge-danger">badge</div>
        </slot>
        <figure class="card__figure">
          <img class="card__image" :src="image" :alt="alt"/>
        </figure>
      </div>
      <div class="card__bottom">
        <div class="card__title">
          <slot name="p-2"></slot>
        </div>
        <div class="card__text">
          <slot name="p-3"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card919",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },

}

</script>

<style scoped>
.card {
  border-radius: 35px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 500px;
}

.card__top {
  position: relative;
  background-color: var(--accentComplimentary);
  padding: 35px 35px 70px 35px;
  z-index: 0;
  display: flex;
  align-items: flex-start;
}

.card__top:has(.card__figure) {
  aspect-ratio: 3/2;
}

.card__bottom {
  position: relative;
  margin-top: -35px;
  background-color: var(--accent);
  padding: 18px;
  border-radius: 35px;
  display: flex;
  gap: 60px;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  z-index: 1;
}

.card__figure {
  position: absolute;
  inset: 0;
  mix-blend-mode: lighten;
  opacity: 0.5;
}

.card__image {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.card--reverse .card__bottom {
  margin-top: 0;
  margin-bottom: -35px;
}

.card--reverse .card__top {
  position: relative;
  padding: 70px 35px 35px 35px;
  align-items: flex-end;
}

.card--primary {
  --accent: var(--primary);
  --accentComplimentary: var(--secondary);
}


</style>